import { SelectOption } from '@web-for-marketing/react-ui';

export function convertToSelectOption(options: string[]): SelectOption[] {
    const typeOptions = options.map((item) => ({ content: item, value: item }));

    return typeOptions;
}
